import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';

type Props = {
  blocked: boolean;
  className?: string;
};

export const ClientBlockChip = ({ blocked, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip
      tone={
        blocked
          ? 'bg-red-100 text-red-800 border-red-200'
          : 'bg-emerald-100 text-emerald-800 border-emerald-200'
      }
      className={className}
    >
      {blocked ? t('clients.list.status.blocked') : t('clients.list.status.active')}
    </Chip>
  );
};
